import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import ReactDOM from "react-dom";
import Slider from "react-slick"; // Import slider library if using react-slick or a similar library
import styled from "styled-components";
import { useHistory } from "react-router-dom"; // For navigation
import {
  getbannerResult,
  getStoryDrafts,
  getPoemDrafts,
} from "../views/utilities/ApiCalls"; // Assuming this fetches banner data // Utility to parse token details
import axios from "axios";
import Constant from "../views/Constant"; // Adjust path as per your project structure
import Layout from "../Layout/Layout";

import { t } from "i18next"; // Assuming i18next is used for translations
import { getTokenDetails } from "../views/utilities/CommonFunction";
import { format } from "date-fns";
import { enUS } from "date-fns/locale";
import { getResponsiveImage } from "../utils/responsiveImage";

import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { Calendar } from "lucide-react";

export const CustomCarousel = forwardRef((props, ref) => {
  const [bannerData, setBannerData] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [currentSlide, setCurrentSlide] = useState(0);
  const history = useHistory();
  const [formError, setFormError] = useState("");
  const sliderRef = React.useRef(null);
  const [isContestDraftModalOpen, setIsContestDraftModalOpen] = useState(false);
  const [contestDraftStep, setContestDraftStep] = useState("choose");
  const [contestDrafts, setContestDrafts] = useState([]);
  const [selectedContestDraftId, setSelectedContestDraftId] = useState("");
  const [contestDraftError, setContestDraftError] = useState("");
  const [loadingContestDrafts, setLoadingContestDrafts] = useState(false);
  const [draftContestMeta, setDraftContestMeta] = useState({
    contestType: "story",
    contestId: "",
    language: "English",
  });

  // Expose navigation methods to parent component
  useImperativeHandle(ref, () => ({
    goToPrev: () => {
      if (sliderRef.current) {
        sliderRef.current.slickPrev();
      }
    },
    goToNext: () => {
      if (sliderRef.current) {
        sliderRef.current.slickNext();
      }
    },
  }));

  const getbanner = async () => {
    try {
      const res = await getbannerResult();
      // ("Banner details", res.data);
      setBannerData(res.data);
    } catch (error) {
      alert("error fetching bannerdata");
      // ("Error in fetching banner details", error);
    }
  };
  useEffect(() => {
    getbanner();
  }, []);

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return format(date, "do MMM yyyy 'at' hh.mm aaaa ('IST')", {
      locale: enUS,
    });
  };

  const getContestIdFromDraft = (draft) => {
    if (!draft || !draft.contestId) return "";
    if (typeof draft.contestId === "string") return draft.contestId;
    if (typeof draft.contestId === "object" && draft.contestId._id) {
      return draft.contestId._id;
    }
    return "";
  };

  const resetContestDraftModal = () => {
    setIsContestDraftModalOpen(false);
    setContestDraftStep("choose");
    setContestDrafts([]);
    setSelectedContestDraftId("");
    setContestDraftError("");
    setLoadingContestDrafts(false);
    setDraftContestMeta({
      contestType: "story",
      contestId: "",
      language: "English",
    });
  };

  const openContestDraftModal = ({ contestType, contestId, language }) => {
    setDraftContestMeta({
      contestType,
      contestId,
      language: language || "English",
    });
    setContestDraftStep("choose");
    setContestDrafts([]);
    setSelectedContestDraftId("");
    setContestDraftError("");
    setLoadingContestDrafts(false);
    setIsContestDraftModalOpen(true);
  };

  const loadContestDrafts = async () => {
    setContestDraftStep("draft");
    setLoadingContestDrafts(true);
    setContestDraftError("");
    setSelectedContestDraftId("");
    try {
      const resp =
        draftContestMeta.contestType === "story"
          ? await getStoryDrafts({ contestId: draftContestMeta.contestId })
          : await getPoemDrafts({ contestId: draftContestMeta.contestId });

      if (resp.status === "Success") {
        const filteredDrafts = (resp.data || []).filter(
          (draft) =>
            getContestIdFromDraft(draft) === String(draftContestMeta.contestId)
        );
        setContestDrafts(filteredDrafts);
      } else {
        setContestDraftError(resp.message || "Unable to load drafts.");
      }
    } catch (e) {
      setContestDraftError("Unable to load drafts.");
    } finally {
      setLoadingContestDrafts(false);
    }
  };

  const goToContestEntry = ({ draftId = "" } = {}) => {
    const basePath =
      draftContestMeta.contestType === "story" ? "/contest-story" : "/contest-poem";
    const query = new URLSearchParams({
      contestId: draftContestMeta.contestId,
      language: draftContestMeta.language || "English",
    });

    if (draftId) {
      query.set("id", draftId);
      query.set("isDraft", "1");
    }

    history.push(`${basePath}?${query.toString()}`);
    resetContestDraftModal();
  };

  const handleContestClick = async (
    language,
    contestId,
    contestName,
    contestType
  ) => {
    const contest = bannerData.find((c) => c.eventId._id === contestId);
    if (contest) {
      const startDateTime = new Date(
        `${contest.eventId.startDate}T${contest.eventId.startTime}`
      );
      const closureDateTime = new Date(
        `${contest.eventId.closureDate}T${contest.eventId.closureTime}`
      );
      const resultDateTime = new Date(
        `${contest.eventId.resultDate}T${contest.eventId.resultTime}`
      );
      const currentDateTime = new Date();
      const userLanguage = language || "English";

      if (
        currentDateTime >= closureDateTime &&
        currentDateTime <= resultDateTime
      ) {
        history.push({
          pathname:
            contestType === "story"
              ? `/contestStories/${contestId}`
              : `/contestPoetries/${contestId}`,
          search: `?resultDate=${resultDateTime}&noVoting=${!!contest.eventId.noVoting}`,
        });
      } else if (
        currentDateTime >= startDateTime &&
        currentDateTime <= closureDateTime
      ) {
        const token = localStorage.getItem("loginDetails");
        const userDetails = token ? getTokenDetails(token) : {};

        try {
          const endpoint =
            contestType === "story" ? "story/filter" : "poem/filter";
          const response = await axios.get(
            `${Constant.apiBasePath}${endpoint}?contestId=${contestId}`
          );
          const stories = response.data;
          const userHasSubmitted = stories.some(
            (story) =>
              story.userId === userDetails._id && story.isDraft === false
          );

          if (userHasSubmitted) {
            setErrorMessage("Story already submitted");
            setTimeout(() => setErrorMessage(""), 3000);
          } else {
            openContestDraftModal({
              contestType,
              contestId,
              language: userLanguage,
            });
          }
          // history.push({
          //   pathname: contestType === "story"
          //     ? `/contest-story`
          //     : `/contest-poem`,
          //   search: `?contestId=${contestId}&language=${userLanguage}`,
          // });
        } catch (error) {
          console.error("Error fetching stories:", error);
        }
      } else if (currentDateTime > resultDateTime) {
        history.push({
          pathname: `/contest-result/${contestId}/${contestType}`,
          state: { contestName },
        });
      }
    }
  };

  const handleOpenMicClick = (id, name) => {
    history.push(`/openmic/${id}`);
  };
  const handleMeetingLink = (item) => {
    history.push({
      pathname: "/Storytent-Meeting",
      state: { meetingConfig: item },
    });
  };
  const handleSimpleBanner = (item) => {
    if (item.link.startsWith("http")) {
      window.location.href = item.link; // Full external URL
    } else {
      history.push(item.link); // Internal route like /contest
    }
  };

  const handleAfterChange = (index) => {
    setCurrentSlide(index); // Update index for the combined slider
  };
  const handleGo = async (EventId) => {
    try {
      const token = await localStorage.getItem("loginDetails");
      const userId = await getTokenDetails(token);
      const response = await axios.post(
        `${Constant.apiBasePath}user-responses/check-submission?userId=${userId._id}&formId=${EventId}`
      );
      // (response.data.submitted);
      if (response.data.submitted) {
        setErrorMessage("Form already submitted");
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
        return;
      } else {
        history.push({
          pathname: `/EventForm/${EventId}`,
          state: { EventId: EventId },
        });
      }
    } catch (error) {
      // (error);
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    arrows: false, // Arrows are now handled by parent component (desktop) or custom arrows (mobile)
  };

  const CustomPrevArrow = () => {
    const handleClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (sliderRef.current) {
        sliderRef.current.slickPrev();
      }
    };
    return (
      <ArrowLeftMobile onClick={handleClick}>
        <IoIosArrowBack
          color="black"
          style={{ fontWeight: "900", fontSize: "16px", strokeWidth: "35px" }}
        />
      </ArrowLeftMobile>
    );
  };

  const CustomNextArrow = () => {
    const handleClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (sliderRef.current) {
        sliderRef.current.slickNext();
      }
    };
    return (
      <ArrowRightMobile onClick={handleClick}>
        <IoIosArrowForward
          color="black"
          style={{ fontWeight: "900", fontSize: "16px", strokeWidth: "35px" }}
        />
      </ArrowRightMobile>
    );
  };

  return (
    <Container>
      <Section>
        {errorMessage && <Error>{errorMessage}</Error>}
        <SliderContainer>
          {/* Mobile arrows - only visible on mobile */}
          <CustomPrevArrow />
          <CustomNextArrow />

          <CustomSlider
            ref={sliderRef}
            {...settings}
            afterChange={handleAfterChange}
          >
            {Array.isArray(bannerData) &&
              bannerData.map((item, index) => {
                const currentDateTime = new Date();
                const isContest = item.type === "contest";
                const startDateTime = isContest
                  ? new Date(
                      `${item.eventId.startDate}T${item.eventId.startTime}`
                    )
                  : null;
                const closureDateTime = isContest
                  ? new Date(
                      `${item.eventId.closureDate}T${item.eventId.closureTime}`
                    )
                  : null;
                const resultDateTime = isContest
                  ? new Date(
                      `${item.eventId.resultDate}T${item.eventId.resultTime}`
                    )
                  : null;
                const handleClick = () => {
                  if (item.type === "contest") {
                    handleContestClick(
                      item.eventId.language,
                      item.eventId._id,
                      item.eventId.name,
                      item.eventId.type
                    );
                  } else if (item.type === "registration") {
                    // history.push({
                    //   pathname: `/EventForm/${item.eventId._id}`,
                    //   state: { EventId: item.eventId._id },
                    // });
                    handleGo(item.eventId._id);
                  } else if (item.type === "meetings") {
                    handleMeetingLink(item.meetingDetails);
                  } else if (item.type === "simple-banner") {
                    handleSimpleBanner(item.eventId);
                  } else {
                    handleOpenMicClick(item.eventId, item.name);
                  }
                };
                // // ("items in ghome poage banner", item);

                // Match desktop image logic exactly
                const imageUrl =
                  item.type === "simple-banner"
                    ? getResponsiveImage(item.mobileImage, item.image)
                    : getResponsiveImage(
                        item.mobileImage,
                        item.type !== "contest" &&
                          typeof item.eventId === "object" &&
                          item.eventId !== null
                          ? item.eventId.thumbnail
                          : item?.image ||
                              "https://images.unsplash.com/photo-1485579149621-3123dd979885?q=80&w=1631&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                      );

                return (
                  <SliderItem key={item._id} onClick={handleClick}>
                    {/* Mobile: Card Design */}
                    <EventCard
                      style={{
                        backgroundImage: `linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.8) 100%), url("${imageUrl}")`,
                      }}
                    >
                      <EventLabel>EVENT</EventLabel>
                      <EventTitle>{item.name}</EventTitle>
                      <EventSubtitle>
                        {item.type === "contest"
                          ? item.eventId?.description || "Contest"
                          : item.type === "registration"
                          ? "Registration Event"
                          : item.type === "meetings"
                          ? "Meeting Event"
                          : item.type === "simple-banner"
                          ? item.eventId?.description || "Event"
                          : "Mega Online Open Mic"}
                      </EventSubtitle>
                    </EventCard>
                    {/* Desktop: Image Carousel */}
                    <EventImageWrapper>
                      {item.type === "simple-banner" ? (
                        <Image
                          src={getResponsiveImage(item.mobileImage, item.image)}
                          alt={item.name || "Image"}
                        />
                      ) : (
                        <Image
                          src={getResponsiveImage(
                            item.mobileImage,
                            item.type !== "contest" &&
                              typeof item.eventId === "object" &&
                              item.eventId !== null
                              ? item.eventId.thumbnail
                              : item?.image ||
                                  "https://images.unsplash.com/photo-1485579149621-3123dd979885?q=80&w=1631&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                          )}
                          alt={item.name || "Image"}
                        />
                      )}
                      {isContest ? (
                        <Title>{item.name}</Title>
                      ) : (
                        <OpenMicTitle>{item.name}</OpenMicTitle>
                      )}
                      {/* Contest status banner removed as requested */}
                    </EventImageWrapper>
                  </SliderItem>
                );
              })}
          </CustomSlider>
        </SliderContainer>
      </Section>
      {isContestDraftModalOpen && ReactDOM.createPortal(
        <DraftModalBackdrop>
          <DraftModal>
            <DraftCloseButton onClick={resetContestDraftModal}>x</DraftCloseButton>
            <DraftTitle>
              {draftContestMeta.contestType === "story"
                ? "Continue your contest story"
                : "Continue your contest poem"}
            </DraftTitle>
            {contestDraftStep === "choose" && (
              <>
                <DraftText>
                  Would you like to start something new or continue from a draft?
                </DraftText>
                <DraftActions>
                  <DraftButtonPrimary onClick={() => goToContestEntry()}>
                    Start New{" "}
                    {draftContestMeta.contestType === "story" ? "Story" : "Poem"}
                  </DraftButtonPrimary>
                  <DraftButtonSecondary onClick={loadContestDrafts}>
                    Choose a Draft
                  </DraftButtonSecondary>
                </DraftActions>
              </>
            )}
            {contestDraftStep === "draft" && (
              <>
                {loadingContestDrafts ? (
                  <DraftText>Loading drafts...</DraftText>
                ) : contestDrafts.length === 0 ? (
                  <DraftText>
                    No drafts found for this contest. You can start a new one.
                  </DraftText>
                ) : (
                  <>
                    <DraftLabel>Select a draft to continue:</DraftLabel>
                    <DraftSelect
                      value={selectedContestDraftId}
                      onChange={(e) => setSelectedContestDraftId(e.target.value)}
                    >
                      <option value="">Select a draft</option>
                      {contestDrafts.map((draft) => (
                        <option key={draft._id} value={draft._id}>
                          {draft.name || "(Untitled)"}{" "}
                          {draft.updatedAt
                            ? `- ${new Date(draft.updatedAt).toLocaleString()}`
                            : ""}
                        </option>
                      ))}
                    </DraftSelect>
                  </>
                )}
                <DraftActions>
                  <DraftButtonPrimary
                    disabled={!selectedContestDraftId}
                    onClick={() => {
                      if (!selectedContestDraftId) return;
                      goToContestEntry({ draftId: selectedContestDraftId });
                    }}
                  >
                    Continue
                  </DraftButtonPrimary>
                  <DraftButtonSecondary
                    onClick={() => {
                      setContestDraftStep("choose");
                      setSelectedContestDraftId("");
                      setContestDraftError("");
                    }}
                  >
                    Back
                  </DraftButtonSecondary>
                </DraftActions>
              </>
            )}
            {contestDraftError && <DraftError>{contestDraftError}</DraftError>}
          </DraftModal>
        </DraftModalBackdrop>,
        document.body
      )}
    </Container>
  );
});

CustomCarousel.displayName = "CustomCarousel";

const ArrowLeftMobile = styled.div`
  position: absolute;
  top: 50%;
  left: -15px;
  transform: translate(0, -50%);
  cursor: pointer;
  z-index: 100;
  color: white;
  width: 24px;
  height: 24px;
  display: none; /* Hidden on desktop */
  justify-content: center;
  align-items: center;
  background-color: rgba(194, 197, 197, 0.75);
  border-radius: 50%;
  pointer-events: auto;

  @media (max-width: 768px) {
    display: flex;
    z-index: 100;
  }
`;

const ArrowRightMobile = styled.div`
  position: absolute;
  top: 50%;
  right: -15px;
  transform: translate(0, -50%);
  cursor: pointer;
  z-index: 100;
  color: white;
  width: 24px;
  height: 24px;
  display: none; /* Hidden on desktop */
  justify-content: center;
  align-items: center;
  background-color: rgba(194, 197, 197, 0.75);
  border-radius: 50%;
  pointer-events: auto;

  @media (max-width: 768px) {
    display: flex;
    z-index: 100;
  }
`;

const CustomSlider = styled(Slider)`
  width: 100%;
  flex: 1;
  overflow: hidden;
  height: 198px;

  .slick-arrow {
    z-index: 100;
  }
  .slick-track {
    display: flex !important;
    height: 198px;
  }
  .slick-slide {
    height: 198px !important;
  }
  .slick-slide > div {
    height: 198px;
  }

  @media (max-width: 768px) {
    height: 100px;

    .slick-track {
      height: 100px;
    }
    .slick-slide {
      height: 100px !important;
    }
    .slick-slide > div {
      height: 100px;
    }
    .slick-dots {
      display: none !important;
    }
  }
`;

const SliderItem = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  cursor: pointer;
  width: 100%;
  height: 198px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.5s ease, box-shadow 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 1;

  @media (max-width: 768px) {
    height: 100px;
  }

  @media (max-width: 480px) {
    height: 100px;
    width: 100%;
    border-radius: 8px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover; // Changed from fill to cover to avoid white gaps
    border-radius: inherit;
  }

  &.active {
    transform: scale(1.05);
    z-index: 1;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
  }

  &:hover {
    opacity: 0.9;
  }
`;
const Image = styled.img`
  width: 100%;
  height: 100%; /* Change from auto to 100% */
  object-fit: fill;
  border-radius: 12px;

  @media (max-width: 768px) {
    height: 100%;
    width: 100%;
  }
`;

const Title = styled.div`
  position: absolute;
  bottom: 20px;
  left: 20px;
  color: #fff;
  font-size: 1.2em;
  font-weight: bold;
  background: rgba(0, 0, 0, 0.7);
  padding: 10px;
  border-radius: 8px;

  @media (max-width: 768px) {
    font-size: 1em; /* Adjust font size for smaller screens */
    left: 10px; /* Adjust position for smaller screens */
    bottom: 50px; /* Ensure it doesn't overlap with the subtitle */
  }
`;
const OpenMicTitle = styled.div`
  position: absolute;
  bottom: 20px;
  left: 20px;
  color: #fff;
  font-size: 1.2em;
  font-weight: bold;
  background: rgba(0, 0, 0, 0.7);
  padding: 10px;
  border-radius: 8px;

  @media (max-width: 768px) {
    font-size: 1em; /* Adjust font size for smaller screens */
    left: 10px; /* Adjust position for smaller screens */
  }
`;

const Subtitle = styled.div`
  position: absolute;
  bottom: 20px;
  right: 20px;
  color: #fff;
  font-size: 0.9em;
  background: rgba(0, 0, 0, 0.7);
  padding: 8px;
  border-radius: 8px;

  @media (max-width: 768px) {
    font-size: 0.8em; /* Adjust font size for smaller screens */
    left: 10px; /* Adjust position for smaller screens */
    bottom: 10px; /* Ensure it fits well with the title */
  }
`;
const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 10px 10px 0px 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    padding: 0px;
  }
`;

const Section = styled.section`
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;

  &:last-child {
    margin-bottom: 0;
  }
`;

const Heading = styled.h1`
  font-size: 1.4em;
  color: var(--color-text);
  text-align: center;
  margin-bottom: 15px;
  cursor: pointer;

  @media (max-width: 768px) {
    display: none;
  }
`;

const Error = styled.div`
  color: red;
  text-align: center;
  font-size: 1.3em;
  margin-bottom: 10px;
`;

const SliderContainer = styled.div`
  width: 100%;
  height: 198px;
  margin: 0 auto;
  gap: 10px;
  align-items: center;
  position: relative;
  border: 1px solid var(--color-border);
  border-radius: 10px;
  padding: 0px;
  background-color: var(--color-surface);
  overflow: hidden;
  display: flex;

  @media (max-width: 768px) {
    height: 100px;
    border: none;
    background-color: transparent;
    gap: 0;
    padding: 0;
    display: block;
    overflow: visible;
    margin-bottom: 0px;
  }
`;

const EventCard = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    width: 100%;
    height: 100%;
    border-radius: 12px;
    padding: 20px;
    flex-direction: column;
    justify-content: center;
    position: relative;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
    transition: transform 0.2s ease;
    box-shadow: 0 8px 20px rgba(255, 107, 107, 0.3);
    margin: 0 auto;
  }
`;

const EventLabel = styled.div`
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #fff;
  text-transform: uppercase;
  opacity: 0.9;
  margin-bottom: 8px;
  text-shadow: 0px 1px 10px rgba(0, 0, 0, 0.75);

  @media (max-width: 768px) {
    font-size: 9px;
    margin-bottom: 6px;
  }
`;

const EventTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 4px;
  line-height: 1.2;
  text-shadow: 0px 1px 10px rgba(0, 0, 0, 0.75);

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const EventSubtitle = styled.div`
  font-size: 13px;
  color: #fff;
  opacity: 0.95;
  line-height: 1.3;
  text-shadow: 0px 1px 10px rgba(0, 0, 0, 0.75);

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const CalendarIcon = styled.div`
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.25);
  padding: 10px;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  backdrop-filter: blur(4px);

  @media (max-width: 768px) {
    right: 18px;
  }
`;

const EventImageWrapper = styled.div`
  display: none;

  @media (min-width: 769px) {
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
  }
`;

const DraftModalBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
`;

const DraftModal = styled.div`
  position: relative;
  width: 90%;
  max-width: 480px;
  background: var(--color-surface);
  border-radius: 10px;
  padding: 24px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.25);
`;

const DraftCloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 12px;
  border: none;
  background: transparent;
  color: var(--color-text);
  font-size: 20px;
  cursor: pointer;
`;

const DraftTitle = styled.h2`
  margin: 0 0 10px;
  color: var(--color-text-tertiary);
  font-size: 22px;
`;

const DraftText = styled.p`
  margin: 0 0 16px;
  color: var(--color-text);
  font-size: 14px;
`;

const DraftActions = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

const DraftBaseButton = styled.button`
  flex: 1;
  min-width: 140px;
  border-radius: 999px;
  border: 1px solid var(--color-border);
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-transform: uppercase;
`;

const DraftButtonPrimary = styled(DraftBaseButton)`
  background: var(--color-text-tertiary);
  color: var(--color-surface);
  border-color: var(--color-text-tertiary);

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

const DraftButtonSecondary = styled(DraftBaseButton)`
  background: transparent;
  color: var(--color-text-tertiary);
`;

const DraftLabel = styled.label`
  display: block;
  margin: 8px 0 6px;
  color: var(--color-text-tertiary);
  font-size: 13px;
  font-weight: 500;
`;

const DraftSelect = styled.select`
  width: 100%;
  margin-bottom: 12px;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  padding: 9px 10px;
  color: var(--color-text);
  background: var(--color-surface);
`;

const DraftError = styled.p`
  margin-top: 10px;
  color: #c0392b;
  font-size: 13px;
`;
